import React, { useEffect, useState, useCallback, useContext } from 'react';
import {
  AccountClient,
  CONFIRM_ADD_PAYMENT_TYPE,
  CONFIRM_INTEGRATED_PAYMENT,
  SETUP_INTEGRATED_PAYMENT
} from '@nile/graphql';
import { useMutation } from '@apollo/client';
import { Modal } from '@superops/ui-design-system';
import { toast, withStripeElements } from '@nile/components';
import { FormattedMessage } from 'react-intl';
import { useElements, useStripe, CardElement } from '@stripe/react-stripe-js';
import StripeCheckoutForm from './StripeCheckoutForm';

const AddCardModal = (props) => {
  const {
    modalActive,
    setupIntentId,
    setModalActive,
    clientSecret,
    getCards,
    client
  } = props;

  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [cardComplete, setCardComplete] = useState(false);
  const [billingDetails, setBillingDetails] = useState({
    email: '',
    phone: '',
    name: ''
  });

  const [confirmIntegratedPayment] = useMutation(CONFIRM_INTEGRATED_PAYMENT, {
    client: AccountClient
  });

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    if (error) {
      elements.getElement('card').focus();
      return;
    }

    if (cardComplete) {
      setProcessing(true);
    }

    const payload = await stripe.confirmCardSetup(clientSecret, {
      payment_method: {
        card: elements.getElement(CardElement),
        billing_details: billingDetails
      }
    });

    setProcessing(false);

    if (payload.error) {
      setError(payload.error);
      toast('error', payload.error.message);
    }
    if (payload.setupIntent?.status === 'succeeded') {
      try {
        const res = await confirmIntegratedPayment({
          variables: {
            setupIntentId
          }
        });

        if (res?.data?.confirmIntegratedPaymentMethod) {
          toast('success', 'admin.integrations.stripe.client.card.success');
          getCards({
            variables: { clientId: client?.accountId, listInfo: {} }
          });
        }
      } finally {
        setModalActive(false);
      }
    }
  };

  return (
    <Modal
      open={modalActive}
      onClose={() => setModalActive(false)}
      title={
        <FormattedMessage id="admin.integrations.stripe.payments.addCard.title" />
      }
    >
      <StripeCheckoutForm
        handleSubmit={handleSubmit}
        error={error}
        setError={setError}
        processing={processing}
        setCardComplete={setCardComplete}
        billingDetails={billingDetails}
        setBillingDetails={setBillingDetails}
        buttonText={
          <FormattedMessage id="admin.integrations.stripe.payments.addCard.buttonText" />
        }
      />
    </Modal>
  );
};

export default withStripeElements(AddCardModal);
